/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface SuiviFichierSearchDto
 */
export interface SuiviFichierSearchDto {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof SuiviFichierSearchDto
     */
    fileName?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof SuiviFichierSearchDto
     */
    uploadUser?: UnaccentTextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SuiviFichierSearchDto
     */
    uploadDate?: DateSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof SuiviFichierSearchDto
     */
    idtypeSuiviFichier?: Int32NullableListSearch;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierSearchDto
     */
    idsuivi?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SuiviFichierSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SuiviFichierSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SuiviFichierSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviFichierSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SuiviFichierSearchDto interface.
 */
export function instanceOfSuiviFichierSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviFichierSearchDtoFromJSON(json: any): SuiviFichierSearchDto {
    return SuiviFichierSearchDtoFromJSONTyped(json, false);
}

export function SuiviFichierSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviFichierSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': !exists(json, 'fileName') ? undefined : UnaccentTextSearchFromJSON(json['fileName']),
        'uploadUser': !exists(json, 'uploadUser') ? undefined : UnaccentTextSearchFromJSON(json['uploadUser']),
        'uploadDate': !exists(json, 'uploadDate') ? undefined : DateSearchFromJSON(json['uploadDate']),
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : Int32NullableListSearchFromJSON(json['idtypeSuiviFichier']),
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SuiviFichierSearchDtoToJSON(value?: SuiviFichierSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': UnaccentTextSearchToJSON(value.fileName),
        'uploadUser': UnaccentTextSearchToJSON(value.uploadUser),
        'uploadDate': DateSearchToJSON(value.uploadDate),
        'idtypeSuiviFichier': Int32NullableListSearchToJSON(value.idtypeSuiviFichier),
        'idsuivi': value.idsuivi,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

